import { render, staticRenderFns } from "./ListaSimulacion.vue?vue&type=template&id=56d6e460&"
import script from "./ListaSimulacion.vue?vue&type=script&lang=js&"
export * from "./ListaSimulacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports